"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getters = void 0;
var getters = {
  // projectCodes(state: RailwayState): Array<Object> {
  //   return state.projectCodes;
  // },
  // drivers(state: RailwayState): Array<Object> {
  //   return state.drivers;
  // },
  // selectedDriver(state: RailwayState): number {
  //   return state.selectedDriver;
  // },
  // trucks(state: RailwayState): Array<Object> {
  //   return state.trucks;
  // },
  // bufferTrucks(state: RailwayState): Array<Object> {
  //   return state.bufferTrucks;
  // },
  // selectedTruck(state: RailwayState): number {
  //   return state.selectedTruck;
  // },
  pagination: function pagination(state) {
    return state.pagination;
  },
  defaultPagination: function defaultPagination(state) {
    return state.defaultPagination;
  },
  defaultTableSize: function defaultTableSize(state) {
    return state.defaultTableSize;
  },
  defaultOrderColumns: function defaultOrderColumns(state) {
    return state.defaultOrderColumns;
  },
  selectedColumns: function selectedColumns(state) {
    return state.selectedColumns;
  },
  orderColumns: function orderColumns(state) {
    return state.orderColumns;
  },
  orderColumnTemplates: function orderColumnTemplates(state) {
    return state.orderColumnTemplates;
  },
  unassignedOrders: function unassignedOrders(state) {
    return state.unassignedOrders;
  },
  excludedOrders: function excludedOrders(state) {
    return state.excludedOrders;
  },
  includedOrders: function includedOrders(state) {
    return state.includedOrders;
  },
  selectedOrders: function selectedOrders(state) {
    return state.selectedOrders;
  },
  orderFilters: function orderFilters(state) {
    return state.orderFilters;
  },
  incidents: function incidents(state) {
    return state.incidents;
  },
  dateRangeOption: function dateRangeOption(state) {
    return state.dateRangeOption;
  },
  startDate: function startDate(state) {
    return state.startDate;
  },
  endDate: function endDate(state) {
    return state.endDate;
  },
  tableLoading: function tableLoading(state) {
    return state.tableLoading;
  },
  plan: function plan(state) {
    return state.plan;
  },
  anyChanges: function anyChanges(state) {
    return state.anyChanges;
  },
  isPlanExists: function isPlanExists(state) {
    return state.isPlanExists;
  },
  defaultLocationType: function defaultLocationType(state) {
    return state.defaultLocationType;
  },
  locationType: function locationType(state) {
    return state.locationType;
  },
  // orderLocationLists(state: RailwayState): Array<string> {
  //   return state.orderLocationLists;
  // },
  // selectedLocation(state: RailwayState): string {
  //   return state.selectedLocation;
  // },
  truckFilters: function truckFilters(state) {
    return state.truckFilters;
  },
  truckLoading: function truckLoading(state) {
    return state.truckLoading;
  },
  searchType: function searchType(state) {
    return state.searchType;
  },
  locations: function locations(state) {
    return state.locations;
  },
  failedOrders: function failedOrders(state) {
    return state.failedOrders;
  },
  savedOrderIds: function savedOrderIds(state) {
    return state.savedOrderIds;
  },
  isManualAssignLoading: function isManualAssignLoading(state) {
    return state.isManualAssignLoading;
  },
  isAssignedDriverChanges: function isAssignedDriverChanges(state) {
    return state.isAssignedDriverChanges;
  },
  isUnassignedDriverChanges: function isUnassignedDriverChanges(state) {
    return state.isUnassignedDriverChanges;
  }
};
exports.getters = getters;